import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import ListingContent from '@spotahome/marketplace-common/src/components/ListingContent';

import { ListingSectionObservable } from './ListingSection';
import ListingTitle from './ListingTitle';

import './ListingSurroundings.scss';

const ListingSurroundings = ({ transportationDescription }) => (
  <ListingSectionObservable section="surroundings">
    <ListingTitle role="secondary">
      {trans('listing.surroundings.title')}
    </ListingTitle>
    {transportationDescription ? (
      <div className="listing-transportation">
        <ListingTitle role="tertiary">
          {trans('property_show.title.transportation')}
        </ListingTitle>
        <ListingContent content={transportationDescription} />
      </div>
    ) : null}
  </ListingSectionObservable>
);
ListingSurroundings.propTypes = {
  transportationDescription: PropTypes.string
};

ListingSurroundings.defaultProps = {
  transportationDescription: ''
};
export default ListingSurroundings;
